import { Box } from "./Box.js";
import { Position } from "./Rectangle.js";
import { createByType } from "./UiConfigs.js";
import { cloneDeep, merge, get, isEqual } from "lodash";
import "./UIElement.js";
import "nanoid";
import "./utils.js";
import "./UIService.js";
import "../global-33d5eebf.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "../console/flags.js";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
import "./Button.js";
import "./ImageBox.js";
import "./Text.js";
import "./TextInput.js";
const generateEventListener = (events, contextRef, eventListener) => {
  return events ? {
    onEscape: (playerIndex) => {
      if (events.escape) {
        eventListener(playerIndex, events.escape, "escape", contextRef.context);
      }
    },
    onClick: (playerIndex) => {
      if (events.click) {
        eventListener(playerIndex, events.click, "click", contextRef.context);
      }
      if (events.trigger) {
        eventListener(playerIndex, events.trigger, "trigger", contextRef.context);
      }
      return false;
    },
    onMouseDown: (playerIndex) => {
      if (events.mouseDown) {
        eventListener(playerIndex, events.mouseDown, "mouseDown", contextRef.context);
      }
      return false;
    },
    onMouseUp: (playerIndex) => {
      if (events.mouseUp) {
        eventListener(playerIndex, events.mouseUp, "mouseUp", contextRef.context);
      }
      return false;
    },
    onMouseEnter: (playerIndex) => {
      if (events.mouseEnter) {
        eventListener(playerIndex, events.mouseEnter, "mouseEnter", contextRef.context);
      }
      if (events.hoverFocus) {
        eventListener(playerIndex, events.hoverFocus, "hoverFocus", contextRef.context);
      }
    },
    onMouseLeave: (playerIndex) => {
      if (events.mouseLeave) {
        eventListener(playerIndex, events.mouseLeave, "mouseLeave", contextRef.context);
      }
      if (events.hoverBlur) {
        eventListener(playerIndex, events.hoverBlur, "hoverBlur", contextRef.context);
      }
    },
    onBlur: (playerIndex) => {
      if (events.blur) {
        eventListener(playerIndex, events.blur, "blur", contextRef.context);
      }
    },
    onFocus: (playerIndex) => {
      if (events.focus) {
        eventListener(playerIndex, events.focus, "focus", contextRef.context);
      }
    }
  } : {};
};
const registeredClasses = /* @__PURE__ */ new Map();
const registerUiClass = (className, styles) => {
  registeredClasses.set(className, styles);
};
const registeredTemplates = /* @__PURE__ */ new Map();
const registerTemplate = (templateName, template) => {
  registeredTemplates.set(templateName, template);
};
const testQuery = (key, value, json, parent) => {
  if (value.includes("$$")) {
    const test = /(\$\$[a-zA-Z0-9_.]+)/g;
    let match = test.exec(value);
    if (!match) {
      return;
    }
    if (match[0].length === value.length) {
      return {
        query: value.slice(2),
        key,
        parent,
        pointer: json
      };
    }
    const partial = {
      source: value,
      start: match.index,
      end: match[0].length + match.index
    };
    return {
      query: value.slice(partial.start + 2, partial.end),
      key,
      parent,
      partial,
      pointer: json
    };
  }
};
const remapTemplateQueries = (json, contextMap, parent = "") => {
  Object.entries(json).forEach(([key, value]) => {
    if (typeof value === "string") {
      const query = testQuery(key, value, json, parent);
      if (query) {
        if (!query.partial) {
          const contextValue = contextMap[query.query];
          if (contextValue !== void 0) {
            json[key] = contextValue;
          }
        } else {
          const contextValue = contextMap[query.query];
          if (contextValue !== void 0) {
            json[key] = query.partial.source.slice(0, query.partial.start) + contextValue + query.partial.source.slice(query.partial.end);
          }
        }
      }
    } else if (Array.isArray(value)) {
      value.map((v) => remapTemplateQueries(v, contextMap, parent ? `${parent}.${key}` : key));
    } else if (typeof value === "object") {
      remapTemplateQueries(value, contextMap);
    }
  });
};
const buildUiMap = (json, boxPosition, boxConfig) => {
  json = cloneDeep(json);
  const lastContext = [];
  let buildContext = null;
  const build = (context2, eventHandler) => {
    buildContext = cloneDeep(context2);
    const getQueriables = (json2, parent = "") => {
      return Object.entries(json2).map(([key, value]) => {
        if (typeof value === "string") {
          if (value.includes("$$")) {
            return testQuery(key, value, json2, parent) || [];
          }
        } else if (Array.isArray(value)) {
          if (key === "children" || key === "element") {
            return [];
          }
          return value.map((v) => getQueriables(v)).flat();
        } else if (typeof value === "object") {
          if (key === "children" || key === "element") {
            return [];
          }
          return getQueriables(value, parent ? `${parent}.${key}` : key);
        }
        return [];
      }).flat();
    };
    const recursiveBuild = (json2, parent, contextRef, buildQueries) => {
      Object.entries(json2).forEach(([key, value]) => {
        var _a, _b;
        if (!value.type) {
          return recursiveBuild(value, parent, contextRef, buildQueries);
        }
        if (value.type === "template") {
          const config2 = cloneDeep(value.config);
          const [template, element2] = config2.template.split(".");
          delete config2.template;
          if (registeredTemplates.has(template)) {
            const elements = element2 ? [element2] : [...Object.keys(registeredTemplates.get(template))];
            elements.forEach((element3) => {
              let templateJson = cloneDeep(registeredTemplates.get(template)[element3]);
              let templateContext = contextRef.context;
              if (templateJson) {
                if (value.context) {
                  remapTemplateQueries(templateJson, value.context);
                }
                templateJson.config = merge(templateJson.config, config2);
                if (value.rect) {
                  templateJson.rect = merge(templateJson.rect, value.rect);
                }
                recursiveBuild({ template: templateJson }, parent, { context: templateContext }, buildQueries);
              }
            });
          }
          return;
        }
        if (value.type === "grid") {
          const gridQueriables = getQueriables(value);
          if (gridQueriables.length) {
            gridQueriables.forEach(({ query, key: key2, pointer }) => {
              const contextValue = get(contextRef.context, query);
              if (key2 === "items") {
                pointer[key2] = contextValue;
                return;
              }
              if (contextValue !== void 0) {
                pointer[key2] = contextValue;
              }
            });
          }
          const gridPosition = new Position(value.rect.x, value.rect.y, {
            ...value.rect
          });
          const gridConfig = {
            ...value.config,
            renderOnScroll: true,
            style: {
              border: "none",
              display: "flex",
              flexWrap: "wrap",
              overflow: "auto",
              padding: "2px",
              alignContent: "flex-start",
              boxSizing: "border-box",
              pointerEvents: "none",
              gap: ((_a = value.config) == null ? void 0 : _a.gap) || "0",
              ...(_b = value.config) == null ? void 0 : _b.style
            }
          };
          const grid = new Box(gridPosition, gridConfig);
          gridQueriables.forEach((query) => {
            if (query.key === "items") {
              query.pointer = (_context) => {
                const items = get(_context, query.query);
                buildChildren(items);
                return false;
              };
              return;
            }
            query.pointer = (_context) => {
              let contextValue = get(_context, query.query);
              if (contextValue !== void 0) {
                if (query.partial) {
                  contextValue = query.partial.source.slice(0, query.partial.start) + contextValue + query.partial.source.slice(query.partial.end);
                }
                if (query.parent === "config" || !query.parent) {
                  if (grid.config[query.key] !== contextValue) {
                    grid.config[query.key] = contextValue;
                    return true;
                  }
                } else {
                  const parent2 = get(grid, query.parent);
                  if (parent2 && parent2[query.key] !== contextValue) {
                    parent2[query.key] = contextValue;
                    return true;
                  }
                }
                return true;
              }
              return false;
            };
          });
          let childContexts = [];
          let childQueries = [];
          let buildChildren = (items) => {
            var _a2;
            if (!items) {
              return;
            }
            if (childContexts.length > items.length) {
              const childrenToRemove = grid.config.children.splice(items.length);
              childrenToRemove.forEach((child) => {
                child.onDestroy(true);
              });
              childContexts = childContexts.slice(0, items.length);
              childQueries = childQueries.slice(0, items.length);
            }
            for (let i = 0; i < items.length; i++) {
              const itemContext = { ...contextRef.context, ...cloneDeep(items[i]) };
              itemContext.$context = contextRef.context;
              itemContext.$index = i;
              if (!childQueries[i]) {
                childQueries[i] = [];
                childContexts[i] = { context: itemContext };
              } else {
                if (isEqual(childContexts[i].context, itemContext)) {
                  continue;
                }
                childQueries[i].forEach(([element2, query]) => {
                  query.forEach(({ pointer }) => typeof pointer === "function" && pointer(itemContext));
                });
                childContexts[i].context = itemContext;
                continue;
              }
              const itemJson = {
                ...cloneDeep(value.element),
                // rect: {
                //   x: 0,
                //   y: 0,
                //   width: "100%",
                //   height: "100%",
                // },
                config: {
                  ...value.element.config,
                  style: {
                    position: "relative",
                    flex: "0 0 auto",
                    pointerEvents: "auto",
                    ...(_a2 = value.element.config) == null ? void 0 : _a2.style
                  }
                }
              };
              recursiveBuild({ child: itemJson }, grid, childContexts[i], childQueries[i]);
            }
          };
          const queriables2 = [grid, gridQueriables];
          buildQueries.push(queriables2);
          buildChildren(value.items);
          parent.addChild(grid);
          return;
        }
        value.config = value.config || {};
        const queriables = getQueriables(value);
        if (queriables.length) {
          queriables.forEach((query) => {
            const pointer = query.pointer;
            let contextValue = get(contextRef.context, query.query);
            if (query.partial) {
              contextValue = query.partial.source.slice(0, query.partial.start) + contextValue + query.partial.source.slice(query.partial.end);
            }
            pointer[query.key] = contextValue;
          });
        }
        const rect = new Position(value.rect.x, value.rect.y, {
          ...value.rect
        });
        if (value.events) {
          const events = generateEventListener(value.events, contextRef, eventHandler);
          Object.entries(events).forEach(([key2, event]) => {
            value.config[key2] = event;
          });
        }
        if (value.config.class) {
          const _classes = value.config.class.split(" ");
          const styles = _classes.reduce((acc, className) => {
            return { ...acc, ...registeredClasses.get(className) };
          }, {});
          value.config.style = { ...styles, ...value.config.style };
        }
        const config = {
          type: value.type,
          rect,
          config: value.config
        };
        const element = createByType(config);
        queriables.forEach((query) => {
          query.pointer = (_context) => {
            let contextValue = get(_context, query.query);
            if (query.key === "events") {
              const events = generateEventListener(contextValue, contextRef, eventHandler);
              let shouldUpdate = false;
              Object.entries(events).forEach(([key2, value2]) => {
                element.config[key2] = value2;
                shouldUpdate = true;
              });
              return shouldUpdate;
            }
            if (query.partial) {
              contextValue = query.partial.source.slice(0, query.partial.start) + contextValue + query.partial.source.slice(query.partial.end);
            }
            if (query.parent === "config" || !query.parent) {
              if (element.config[query.key] !== contextValue) {
                element.config[query.key] = contextValue;
                return true;
              }
            } else {
              const parent2 = get(element, query.parent);
              if (parent2 && parent2[query.key] !== contextValue) {
                parent2[query.key] = contextValue;
                return true;
              }
            }
            return false;
          };
        });
        if (queriables.length) {
          buildQueries.push([element, queriables]);
        }
        parent.addChild(element);
        if (value.children) {
          recursiveBuild(value.children, element, contextRef, buildQueries);
        }
        return element;
      });
    };
    json = cloneDeep(json);
    const res = {};
    Object.entries(json).forEach(([key, value]) => {
      if (!value.type) {
        throw new Error("No nesting");
      }
      let childIndex = 0;
      recursiveBuild(
        { parent: value },
        {
          addChild: (element) => {
            if (childIndex === 0) {
              res[key] = element;
            } else {
              res[`${key}.${childIndex}`] = element;
            }
            childIndex++;
          }
        },
        { context: context2 },
        lastContext
      );
    });
    if (boxPosition) {
      const box = new Box(boxPosition, boxConfig);
      Object.entries(res).forEach(([key, value]) => {
        box.addChild(value);
      });
      return { box };
    }
    return res;
  };
  const update = (partialContext) => {
    Object.keys(partialContext).forEach((key) => {
      buildContext[key] = cloneDeep(partialContext[key]);
    });
    lastContext.forEach(([element, elementQueries]) => {
      for (let i = 0; i < elementQueries.length; i++) {
        const pointer = elementQueries[i].pointer;
        if (typeof pointer === "function") {
          pointer(buildContext);
        }
      }
    });
    return;
  };
  const context = () => {
    return cloneDeep(buildContext);
  };
  return { build, update, context };
};
export {
  buildUiMap,
  registerTemplate,
  registerUiClass
};
//# sourceMappingURL=UiMap.js.map
